import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { chooseOptionsConstant } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import * as $ from 'jquery';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { INSTRUCTION } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-instructions-modal',
  templateUrl: './instructions-modal.component.html',
  styleUrls: ['./instructions-modal.component.scss']
})
export class InstructionsModalComponent implements OnInit {
  @Input() public Content: any;

  formFields;
  loiOptions = chooseOptionsConstant;
instruct : INSTRUCTION []=[]
  content: any;
  heading: string;
  FORMDATA;
  program;
  action: Subject<any> = new Subject();
  instructionsForm = new UntypedFormGroup({
    ID: new UntypedFormControl(""),
    CODE: new UntypedFormControl(""),
    NAME: new UntypedFormControl(""),
    DESCRIPTION: new UntypedFormControl(""),
    MODULE_ID :new UntypedFormControl(""),
    // SCREENTEXT: new UntypedFormControl(""),
    ModuleStr:new UntypedFormControl(""),
    SHOWINSTRUCTIONTOUSER: new UntypedFormControl(false)
  });
  

  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private Commonservice:CommonService
  ) {
  }

  ngOnInit() {
    if (this.Content.content && this.Content.content.id  ) { // Edit mode
      this.summaryService.getSummaryData('api/instruction/getinstructionbyid/' + this.Content.content.id).subscribe((result) => {
       
        this.setForm(result);
      
        // this.program = result.MODULE_ID=="2" ? result.ModuleStr :
        // result.MODULE_ID=="5" ? result.ModuleStr :
        // result.MODULE_ID=="4" && result.CODE == "6"  ? result.ModuleStr : 
        // result.MODULE_ID=="4" && result.CODE == "7"  ? result.ModuleStr:
        // result.MODULE_ID=="4" && result.CODE == "8"  ? result.ModuleStr : 
        // result.MODULE_ID=="4" && result.CODE == "9"  ? result.ModuleStr  :
        // result.MODULE_ID=="4" && result.CODE == "10"  ? result.ModuleStr :
        // result.MODULE_ID=="4" && result.CODE == "11"  ? result.ModuleStr : ""
        // ;

        this.program = result.ModuleStr;

        if (this.Content.heading === 'View') {
          setTimeout(() => {
            this.instructionsForm.disable({ emitEvent: false });
          }, 100);
        }
      });
    }

  }




  private setForm(result: any): void {
    this.instructionsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      CODE: new UntypedFormControl(result.CODE, [Validators.maxLength(50)]),
      NAME: new UntypedFormControl(result.NAME, [Validators.required, Validators.maxLength(100)]),
      DESCRIPTION: new UntypedFormControl(result.DESCRIPTION , [Validators.required]),
      SCREENTEXT:new UntypedFormControl(result.SCREENTEXT),
      MODULE_ID:new UntypedFormControl(result.MODULE_ID ),
      ModuleStr:new UntypedFormControl(result.ModuleStr),
      SHOWINSTRUCTIONTOUSER: new UntypedFormControl(result.SHOWINSTRUCTIONTOUSER)
     

    });
  }

  save() {
    if (this.validateControls()) {

      this.summaryService.Insert('api/instruction/update', this.instructionsForm.value).subscribe(result => {
        if (result.Status === 0) {
          // this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Instruction Updated Successfully.' } } });
        //  this.action.next();
          this.modalRef.close();
          // this.Commonservice.getScreenPermission("613","E");
          this.Commonservice.SuccessBanner('User Instruction ' + this.instructionsForm.controls['NAME'].value + ' updated successfully' )
        }
        else {
          this.Commonservice.ValidationBanner(result.Message);
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
          // this.Commonservice.ErrorBanner("Error message");
        }
      })
    }
    
  }

  validateControls(): boolean
   {
    let isValid = true;
    let message = "";
    const formData = this.instructionsForm.getRawValue();

    if (formData.NAME === null || formData.NAME === "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter User Instruction Name<br/>";
      isValid = false;
    } else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.CODE === null || formData.CODE === "") {
      $("#CODE").addClass("ng-touched ng-invalid validate-error");
      $("#CODE").removeClass("ng-untouched ng-valid");
      message += "Please enter Code<br/>";
      isValid = false;
    } else {
      $("#CODE").addClass("ng-untouched ng-valid");
      $("#CODE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.DESCRIPTION == null || formData.DESCRIPTION == "" || formData.DESCRIPTION == "\n") {
      $("#DESCRIPTION").addClass("ng-touched ng-invalid validate-error");
      $("#DESCRIPTION").removeClass("ng-untouched ng-valid");
      message += "Please enter Description<br/>";
      isValid = false;
    } else {
      $("#DESCRIPTION").addClass("ng-untouched ng-valid");
      $("#DESCRIPTION").removeClass("ng-touched ng-invalid validate-error");
    }
    // formData.SHOWINSTRUCTIONTOUSER = this.instructionsForm.controls["SHOWINSTRUCTIONTOUSER"].value ? 1 : 0;

   


    if (!isValid)
    this.Commonservice.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });

    return isValid;
  }

}
